import React, { useCallback } from "react";
import { RouteComponentProps } from "react-router";
import { BookingSearch } from "./BookingSearch/BookingSearch";
import { checkIfDirectRoute } from "@utils/navigationUtils";
import { store } from "@store";
import { BOOKING_SLIDER, BookingEditLocation, BookingProfileLocation } from "@navigation";
import { TravelConfirmationViewLocation } from "@bookings/BookingHospitality/locations/TravelConfirmationViewLocation";
import { AccommodationConfirmationViewLocation } from "@bookings/BookingHospitality/locations/AccommodationConfirmationViewLocation";
import { TravelRequestViewLocation } from "./BookingHospitality/locations/TravelRequestViewLocation";
import { AccommodationRequestViewLocation } from "./BookingHospitality/locations/AccommodationRequestViewLocation";
// import { TravelRequestLocation } from "./BookingHospitality/locations/TravelRequestLocation";
// import { AccommodationRequestCreateLocation } from "./BookingHospitality/locations/AccommodationRequestCreateLocation";

type Props = RouteComponentProps<any>;

export function BookingSearchPage(props: Props) {
  const { url } = props.match;
  const { navigation } = store();

  const onOpen = useCallback(
    (id: string, tab?: string, scrollContainer?: HTMLElement) => {
      const scrollTop = scrollContainer?.scrollTop;

      const instance = navigation.open(BOOKING_SLIDER, new BookingProfileLocation(id));

      if (scrollContainer) {
        const restoreScroll = () => {
          requestAnimationFrame(() => {
            scrollContainer.scrollTo({ top: scrollTop });
          });
        };

        instance.afterClose.on(restoreScroll);
      }
    },
    [navigation]
  );

  const onEdit = useCallback(
    (id: string) => {
      return navigation.open(BOOKING_SLIDER, new BookingEditLocation(id));
    },
    [navigation]
  );

  return (
    <>
      {catchDirectUrl(url)}
      <BookingSearch onOpen={onOpen} onEdit={onEdit} />
    </>
  );
}

function catchDirectUrl(url) {
  return checkIfDirectRoute(
    `${url}/:bookingId?/:tab?/:subId?`,
    BOOKING_SLIDER,
    ({ action1, bookingId, tab, subId }) => {
      const action = action1 || "view";
      const realId = bookingId !== "new" ? bookingId : null;

      if (tab === "accommodation-confirmation") {
        return new AccommodationConfirmationViewLocation({
          bookingId,
          confirmationId: subId
        });
      }

      if (tab === "travel-confirmation") {
        return new TravelConfirmationViewLocation({ bookingId, confirmationId: subId });
      }

      if (bookingId === "new" || (bookingId && action === "edit")) {
        return new BookingEditLocation(realId);
      }

      if (bookingId === "travel-request" && tab) {
        return new TravelRequestViewLocation({
          requestId: tab
        });
      }

      if (bookingId === "accommodation-request" && tab) {
        return new AccommodationRequestViewLocation({
          requestId: tab
        });
      }

      // Development direct urls
      // TODO: Refactor to get bookingGroupId, consultantData from the booking
      // if (tab === "travel-request") {
      //   return new TravelRequestLocation({
      //     bookingId,
      //     bookingGroupId: "67d92e2d2f6f426f5f32c124",
      //   });
      // }

      // if (tab === "accommodation-request") {
      //   return new AccommodationRequestCreateLocation({
      //     bookingId,
      //     formProps: {
      //       initialValues: null,
      //       isDisabled: false,
      //       isNew: true
      //     }
      //   });
      // }

      if (bookingId && action === "view") {
        return new BookingProfileLocation(realId, tab);
      }
    }
  );
}
